import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { IconMore } from '@sm/wds-icons';
import { Button, Menu, MenuItem } from '@sm/wds-react';

import FilePreviewer from 'sma.common/components/file_previewer';

export default function ActionMenu(props) {
	const handleViewClick = () => {
		const file = {
			url: `${props.mediaUrl}${props.filePath}`,
			type: 'file',
			name: props.fileName,
		};
		if (props.convertedFilePath) {
			file['converted_url'] = `${props.mediaUrl}${props.convertedFilePath}`;
		}
		const config = {
			files: [file]
		};

		new FilePreviewer(config);
	};

	const handleDeleteClick = () => {
		props.handleFileDelete(props.index, props.filePath);
	};

	const menuTrigger = (
		<Button
			color="secondary"
			icon="only"
			buttonType="button"
		>
			<IconMore/>
		</Button>
	);

	const menuItems = (
		<Fragment>
			{
				props.filePath
				&& (
					<Fragment>
						<MenuItem onClick={handleViewClick}>{gettext('View')}</MenuItem>
						<MenuItem
							navigationTarget={`${props.mediaUrl}${props.filePath}`}
							isNavigable
							download
						>
							{gettext('Download')}
						</MenuItem>
					</Fragment>
				)
			}
			<MenuItem onClick={handleDeleteClick}>{gettext('Delete')}</MenuItem>
		</Fragment>
	);

	return (

		<Fragment>
			<Menu
				autoClose="false"
				dense
				noRules
				menuTrigger={menuTrigger}
			>
				{ menuItems }
			</Menu>
		</Fragment>
	);
}

ActionMenu.propTypes = {
	index: PropTypes.number.isRequired,
	mediaUrl: PropTypes.string.isRequired,
	handleFileView: PropTypes.func,
	handleFileDelete: PropTypes.func,
	handleFileDownload: PropTypes.func,
	filePath: PropTypes.string,
	convertedFilePath: PropTypes.string,
	fileName: PropTypes.string,
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.fs/surveys/form-fields/file-upload/ActionMenu.jsx